/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_F3_TitleInputs */

const en_landing_features_f3_title = /** @type {(inputs: Landing_Features_F3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A brush, not a guess`)
};

const zh_landing_features_f3_title = /** @type {(inputs: Landing_Features_F3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用画笔指定，而不是靠猜`)
};

/**
* | output |
* | --- |
* | "A brush, not a guess" |
*
* @param {Landing_Features_F3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_f3_title = /** @type {((inputs?: Landing_Features_F3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_F3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_f3_title(inputs)
	return zh_landing_features_f3_title(inputs)
});
export { landing_features_f3_title as "landing.features.f3_title" }